import { useEffect, useRef, useState } from 'react';

const reasons = [
  {
    icon: 'ri-user-search-line',
    title: 'Des sites qui attirent des',
    titleAccent: 'clients',
    description:
      'Je ne crée pas juste un site, je crée un outil qui travaille pour vous, attire et convertit vos visiteurs.',
  },
  {
    icon: 'ri-hand-heart-line',
    title: 'Simple, clair,',
    titleAccent: 'sans prise de tête',
    description:
      "Je vous accompagne de A à Z, sans jargon technique, pour un projet fluide et sans stress.",
  },
  {
    icon: 'ri-shield-star-line',
    title: 'Une image qui inspire',
    titleAccent: 'confiance',
    description:
      'Un design moderne et soigné qui valorise votre activité et donne envie de vous choisir.',
  },
  {
    icon: 'ri-rocket-line',
    title: '',
    titleAccent: 'Rapide',
    titleAfter: ', sans compromis sur la qualité',
    description:
      "Un site professionnel livré rapidement, prêt à être utilisé pour développer votre activité.",
  },
];

export default function WhyMe() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      id="why-me"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className={`mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs font-semibold tracking-[0.2em] uppercase text-brand mb-4 block">
            Avantages
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-medium text-white mb-4">
            Pourquoi travailler avec moi ?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={reason.title}
              className={`flex flex-col gap-5 p-8 rounded-2xl glass-card transition-all duration-700 hover:scale-[1.02] hover:-translate-y-1 ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${0.1 + index * 0.1}s` }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-brand/10">
                <i className={`${reason.icon} text-2xl text-brand`}></i>
              </div>
              <div className="flex-1 flex flex-col">
                <h3 className="text-lg font-display font-medium text-white mb-3 leading-snug">
                  {reason.title}{reason.titleAccent && <span className="text-brand"> {reason.titleAccent}</span>}{reason.titleAfter}
                </h3>
                <p className="text-sm text-white/50 leading-relaxed font-light flex-1">
                  {reason.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
